import {
	Button,
	Flex,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	Text,
} from '@chakra-ui/react'
import { GetIcon, Icons } from '@ds/Icons'
import { DDSTheme, ddsTokens } from '@ds/index'
import { useEffect } from 'react'

import { TEXT_ENUM } from '@/styles/components/text'

import { Granularity, TimeFrame } from '../types'
import { getAvailableGranularityOptions } from '../utils'
import { ALL_GRANULARITY_OPTIONS } from '../utils'

interface GranularitySelectProps {
	value: Granularity
	onChange: (value: Granularity) => void
	datePreset: TimeFrame
}

export const GranularitySelect = ({
	value,
	onChange,
	datePreset,
}: GranularitySelectProps) => {
	const availableOptions = getAvailableGranularityOptions(datePreset)
	const tokens = ddsTokens[DDSTheme.light]

	useEffect(() => {
		const isCurrentGranularityAvailable = availableOptions.some(
			(option) => option.value === value,
		)

		if (!isCurrentGranularityAvailable && availableOptions.length > 0) {
			onChange(availableOptions[0].value as Granularity)
		}
	}, [datePreset, value, availableOptions, onChange])

	const selectedOption = ALL_GRANULARITY_OPTIONS.find(
		(option) => option.value === value,
	)

	return (
		<Flex alignItems="center" gap={2}>
			<Text variant={TEXT_ENUM.regular14}>Time Period:</Text>
			<Menu placement="bottom-end">
				<MenuButton
					as={Button}
					rightIcon={<GetIcon icon={Icons.chevron_down} boxSize={4} />}
					bg="white"
					border={`1px solid ${tokens.primitive.light.gray[300]}`}
					borderRadius="md"
					height="35px"
					minWidth="120px"
					fontWeight="medium"
					fontSize="14px"
					pl={0}
				>
					{selectedOption?.label || 'Select'}
				</MenuButton>
				<MenuList zIndex={9999}>
					{availableOptions.map((option) => (
						<MenuItem
							key={option.value}
							onClick={() => onChange(option.value as Granularity)}
						>
							{option.label}
						</MenuItem>
					))}
				</MenuList>
			</Menu>
		</Flex>
	)
}
